module.exports = __webpack_public_path__ + "img/eyein-partner-dlink.6786d858.png";